import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { LibraryCard, CardActions, colors } from 'src/components/app-ui'
import CourseToolBar from 'src/components/course-card/course-tool-bar'
import { courseGetSuccess } from 'src/reducers/course/action'
import { clearCardState } from 'src/reducers/card/action'
import URL from 'src/api/url/api'
import { formatShortDate } from 'src/utils/library-sort'
import { coursePath } from 'src/pages/course-detail/tabs'

const DEFAULT_COVER =
  'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/Default.png'

const useStyles = makeStyles({
  date: {
    fontSize: '13px',
    color: colors.subtle,
  },
})

export const getCourseCover = thumbnail => {
  if (!thumbnail) return DEFAULT_COVER
  return thumbnail.includes('http') ? thumbnail : URL.CDN + thumbnail
}

const CourseLibraryCard = ({ course, localCourses, setLocalCourses }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const openCourse = () => {
    dispatch(clearCardState())
    dispatch(courseGetSuccess(null))
    history.push(coursePath(course.id))
    window.scrollTo(0, 0)
  }

  return (
    <LibraryCard
      cover={getCourseCover(course.thumbnail)}
      coverKey={`course:${course.id}`}
      status={course.isPublished === false ? 'Draft' : 'Published'}
      statusNote={
        // A draft course has nothing live yet, so no "unpublished changes".
        course.hasUnpublishedChanges && course.isPublished !== false
          ? {
              label: 'Unpublished changes',
              tooltip: "Edited pages aren't live yet.",
            }
          : null
      }
      kind="COURSE"
      kindIcon="tabler:book"
      title={course.name}
      onClick={openCourse}
      footer={
        <>
          <span className={classes.date}>
            {formatShortDate(course.updatedAt || course.createdAt)}
          </span>
          <CourseToolBar
            course={course}
            localCourses={localCourses}
            setLocalCourses={setLocalCourses}
            renderTrigger={({ openMenu, openAnalytics }) => (
              <CardActions onAnalytics={openAnalytics} onMenu={openMenu} />
            )}
          />
        </>
      }
    />
  )
}

export default CourseLibraryCard
